var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0C6.7155 0 0 6.714 0 15C0 23.283 6.7155 30 15 30C23.2845 30 30 23.283 30 15C30 6.714 23.2845 0 15 0ZM15.42 21.795C15.2295 21.9855 14.977 22.1014 14.7083 22.1215C14.4397 22.1416 14.1727 22.0646 13.956 21.9045L13.8285 21.795L7.8285 15.795C7.63758 15.6044 7.52149 15.3516 7.50139 15.0826C7.48129 14.8136 7.55852 14.5463 7.719 14.3295L7.8285 14.202L13.83 8.202C14.0307 8.00071 14.3002 7.88288 14.5843 7.8722C14.8684 7.86151 15.146 7.95877 15.3613 8.14442C15.5765 8.33006 15.7136 8.59033 15.7448 8.87289C15.776 9.15545 15.6991 9.43934 15.5295 9.6675L15.4215 9.7935L11.3385 13.8735H21.375C21.6473 13.8732 21.9105 13.9717 22.1158 14.1507C22.321 14.3297 22.4543 14.5771 22.491 14.847L22.4985 15C22.4985 15.2719 22.4 15.5345 22.2214 15.7394C22.0427 15.9443 21.7958 16.0775 21.5265 16.1145L21.3735 16.125H11.3385L15.4185 20.205C15.609 20.3955 15.7249 20.648 15.745 20.9167C15.7651 21.1853 15.6881 21.4523 15.528 21.669L15.4185 21.795H15.42Z",
    fill: "#078950"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.4b98caac.svg";
export { ForwardRef as ReactComponent };